import React from 'react';

import { RoutingContext } from '@cvt/contexts';

export const useRouter = () => {
  const { router } = React.useContext(RoutingContext);
  return router;
};
